import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@users/json-rpc-dispatcher';
import DITypes from '@users/json-rpc-dispatcher/DITypes';
import { ISsoCertificate } from './vo/ISsoCertificate';
import { ISsoCertificatePayload } from './vo/ISsoCertificatePayload';
import { IGetValuesResponse, ISSOPayload } from './vo/SSOForm';

@injectable()
class SSORepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcher) {}

  getValues = async (data: { accountId: number }): Promise<IGetValuesResponse> => {
    const request = new Request('sso.find_by_account_id', data);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  checkIsSSOEmail = async (data: Object) => {
    const request = new Request('sso.is_sso_login_required', data);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  checkDomains = async (data: { domains: string[] }) => {
    const request = new Request('sso.find_existing_domains', data);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  submitSSOForm = async (data: ISSOPayload) => {
    const request = new Request('sso.upsert_by_account_id', data);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  checkShortname = async (data: { shortname: string }) => {
    const request = new Request('sso.find_by_shortname', data);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  };

  async getListCertificates(accountId: number): Promise<ISsoCertificate[]> {
    const request = new Request('sso.get_certificates_by_account_id', { accountId });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  }

  async addCertificate(payload: ISsoCertificatePayload) {
    const request = new Request('sso.create_certificate', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  }

  async deleteCertificate(id: string) {
    const request = new Request('sso.delete_certificate', { id });
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult();
  }
}

export default SSORepository;
